import Block from '../../common.blocks/block'

export default class ProductOverview extends Block {
	static title = 'product-overview'

	constructor($el) {
		super($el)
	}
}
